import type { QualityTier } from "../types/exhibition";

interface NavigatorWithMemory extends Navigator {
  readonly deviceMemory?: number;
}

export function detectQualityTier(): QualityTier {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return "reduced-motion";
  }

  const memory = (navigator as NavigatorWithMemory).deviceMemory ?? 8;
  const cores = navigator.hardwareConcurrency ?? 8;
  const pixels = window.screen.width * window.screen.height * window.devicePixelRatio;
  const compactViewport = window.matchMedia("(max-width: 899px)").matches;
  const coarsePointer = window.matchMedia("(pointer: coarse)").matches;

  if (compactViewport || coarsePointer) {
    return "low";
  }

  if (memory >= 8 && cores >= 8 && pixels <= 16_000_000) return "high";
  if (memory >= 4 && cores >= 4) return "medium";
  return "low";
}

export function qualityPixelRatio(
  tier: QualityTier,
  deviceRatio = typeof window === "undefined"
    ? 1
    : window.devicePixelRatio || 1,
): number {
  if (tier === "high") return Math.min(deviceRatio, 1.75);
  if (tier === "medium") return Math.min(deviceRatio, 1.25);
  if (tier === "low") return Math.min(deviceRatio, 2);
  return Math.min(deviceRatio, 1.15);
}

export function qualityParticleCount(tier: QualityTier): number {
  if (tier === "high") return 3400;
  if (tier === "medium") return 2200;
  if (tier === "low") return 1100;
  return 600;
}
